import React from 'react'
import { Link, useLocation } from 'react-router-dom';

export default function Checkout() {

  const location = useLocation();

  React.useEffect(() => {
    if (location && location.state && location.state.payment_page) {
      window.location.replace(`${location.state.payment_page}`)
    } else {
      const navigationState = JSON.parse(sessionStorage.getItem('navigationCheckout'));
      console.log("--------", navigationState)
      window.location.replace(`${navigationState.payment_page}`)
    }
  }, [])

  return (
    <div>
      <p style={{ textAlign: "center" }}>You will be redirected to payment screen.</p>
    </div>
  )
}
